/**
 * Utility functions for managing text with embedded issueId information.
 * Format: (issueId: <issueId>)
 *
 */

const ISSUE_ID_PATTERN = /\s*\(issueId:\s*([^)]+)\)$/;
const ISSUE_ID_TEMPLATE = (issueId: string) => ` (issueId: ${issueId})`;

/**
 * addIssueIdToText("This is an issue", "123")  ==>  "This is an issue (issueId: 123)"
 */
export const addIssueIdToText = (text: string, issueId: string): string => {
  return text + ISSUE_ID_TEMPLATE(issueId);
};

/**
 * extractDisplayText("This is an issue (issueId: 123)") ==> "This is an issue"
 */
export const extractDisplayText = (textWithIssueId: string): string => {
  return textWithIssueId.replace(ISSUE_ID_PATTERN, '');
};
